export default __webpack_public_path__ + "static/media/cc.44fe0957.png";